import { html } from '@microsoft/fast-element';
import type { CTA } from './call-to-action.js';

export default html<CTA>`
	<slot name="heading"></slot>
	<slot></slot>
	<slot name="action"></slot>
`;